import { render, staticRenderFns } from "./DataWall.vue?vue&type=template&id=0a9227ce&scoped=true"
import script from "./DataWall.vue?vue&type=script&lang=js"
export * from "./DataWall.vue?vue&type=script&lang=js"
import style0 from "./DataWall.vue?vue&type=style&index=0&id=0a9227ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9227ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VSlideYTransition})
